import Link from "next/link";
import clsx from "clsx";
import styles from "./index.module.scss";

export default function Stick({ stick, lifetimeWarranty }) {
  if (!stick?.NAME && !lifetimeWarranty) return null;

  return (
    <div className={styles.Sticks}>
      {lifetimeWarranty && (
        <Link href="/warranty/">
          <a className={clsx(styles.Stick, styles.StickLifetimeWarranty)}>
            Пожизненная гарантия
          </a>
        </Link>
      )}
      {stick?.NAME && (
        <span className={clsx(styles.Stick, styles[`Stick--${stick?.CODE}`])}>
          {stick?.NAME}
        </span>
      )}
    </div>
  );
}
